import React, { useCallback } from "react";
import { connect } from "react-redux";

import cn from "classnames";

import {
  AnyEntityId,
  EntityType,
  EntityTypesSupportedByActivities,
} from "@mapmycustomers/shared/types/entity";

import configService from "@app/config/ConfigService";
import authService from "@app/store/auth/AuthService";
import { showEntityView } from "@app/store/entityView/actions";
import { getLegacyAppUrl } from "@app/util/appUrl";

import styles from "./EntityLink.module.scss";
import Label from "./Label";

interface Props {
  children: React.ReactNode; // entity name usually
  className?: string;
  entityId: AnyEntityId;
  entityType: EntityTypesSupportedByActivities;
  legacy?: boolean;
  showEntityView: typeof showEntityView;
  showIcon?: boolean;
}

const EntityLink: React.FC<Props> = ({
  children,
  className,
  entityId,
  entityType,
  legacy = true,
  showEntityView,
  showIcon = true,
}) => {
  const handleClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      showEntityView({ entityId, entityType });
    },
    [entityId, entityType, showEntityView]
  );

  const baseOldAppUrl = configService.getBaseOldAppUrl();
  const token = authService.getToken();
  if (!token) {
    return null;
  }

  let path = "";
  switch (entityType) {
    case EntityType.COMPANY:
      path = `/accounts/edit/${entityId}`;
      break;
    case EntityType.DEAL:
      path = `/deals/edit/${entityId}`;
      break;
    case EntityType.PERSON:
      path = `/contacts/edit/${entityId}`;
  }

  return legacy ? (
    <a
      className={cn(styles.container, className)}
      href={getLegacyAppUrl(baseOldAppUrl, token, path)}
    >
      <Label entityType={entityType} showIcon={showIcon}>
        {children}
      </Label>
    </a>
  ) : (
    <span className={cn(styles.container, className)} onClickCapture={handleClick}>
      <Label entityType={entityType} showIcon={showIcon}>
        {children}
      </Label>
    </span>
  );
};
const mapDispatchToProps = {
  showEntityView,
};

export default connect(null, mapDispatchToProps)(EntityLink);
